import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { DateUtil } from '../../../../../core/utils/date-util';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ShiftBreakDetailsComponent } from '../../../../../modules/main/shift-info/components/shift-break-details/shift-break-details.component';
import { CountType } from '../../../../../modules/main/shift-info/pages/shift-info-main/shift-info-main.constant';
import { ModalBaseClass } from '../../modals/base_class/modal-base-class';

@Component({
  standalone: false,
  selector: 'kt-shift-control-details',
  templateUrl: './shift-control-details.component.html',
  styleUrls: ['./shift-control-details.component.scss'],
})
export class ShiftControlDetailsComponent extends ModalBaseClass implements OnInit {

  mathRef = Math;
  @Input() shiftDetails = null;
  @Input() shiftAllInfo = null;
  @Input() showExtraDetails = true;
  @Input() showDateDetails = true;
  @Output() eOpenModal = new EventEmitter<any>();
  countRef = CountType;
  currentDate = null;

  ngOnInit() {
    const dateFormat = LocalStorageUtil.getDateFormat();
    const timeFormat = LocalStorageUtil.getTimeFormat();
    this.currentDate = DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftDetails.location.location_fk_timezone_name).format(`${dateFormat} ${timeFormat}`);
  }
  restBreakHandler() {
    this.openPopUp(ShiftBreakDetailsComponent, { breaks: this.shiftDetails.rest_break, type: BREAK_TYPE_ENUM.MealBreak }, { centered: true, size: 'md', backdrop: 'static' });
  }

  mealBreakHandler() {
    this.openPopUp(ShiftBreakDetailsComponent, { breaks: this.shiftDetails.meal_break, type: BREAK_TYPE_ENUM.RestBreak }, { centered: true, size: 'md', backdrop: 'static' });
  }

  openModal(modalType) {
    this.eOpenModal.emit(modalType);
  }

}
